export const ADMIN_DISPUTES_SLICE_NAME = "adminDisputes"
